import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { configureStore } from './redux/configureStore';
import App from './components/App.jsx';
import 'babel-polyfill';
import {
  MuiThemeProvider, createMuiTheme, createGenerateClassName, jssPreset,
} from '@material-ui/core/styles';
import { customizedThemes } from './css/style';

import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';

/**
 * In the production version, the material-ui class names are binded into shorter format.
 * eg. change from 'MuiTypography-root-1' to 'jss1'
 * but some classes are given the same name. eg. multiple classes have the same name such as 'jss1' , 'jss2' , 'jss3' ...
 * this causes wrong styling is matched for some material-ui components
 * comment that gives idea for solving this issue:
 * https://github.com/mui-org/material-ui/issues/11397#issuecomment-390675123
 * link for solving issue, using JssProvider:
 * https://material-ui.com/customization/css-in-js/#jssprovider
*/
import JssProvider from 'react-jss/lib/JssProvider';
import { create } from 'jss';

// import * as Sentry from '@sentry/browser';
// Sentry.init({ dsn: 'https://625d28a994754e8f9de539f99b1d4bdc@sentry.io/1784331' });

import { Userpilot } from 'userpilot';
Userpilot.initialize('NX-105ee352');

const generateClassName = createGenerateClassName();
const jss = create(jssPreset());

const theme = createMuiTheme(customizedThemes);
const store = configureStore();


ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
      <JssProvider jss={jss} generateClassName={generateClassName}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <App />
        </MuiPickersUtilsProvider>
      </JssProvider>
    </MuiThemeProvider>
  </Provider>,
  document.getElementById('app'),
);
